var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1245 22.2391C13.1245 22.2446 13.125 22.2501 13.125 22.2556C13.125 23.6367 11.7259 24.7563 10 24.7563C8.27411 24.7563 6.875 23.6367 6.875 22.2556L6.87552 22.2391H13.1245ZM9.99999 0.5C10.7115 0.5 11.2883 1.0885 11.2884 1.81437V3.29928C14.3 3.91017 16.5701 6.62093 16.5701 9.87295V14.6951L19.1492 18.5602C19.4208 18.9673 19.4496 19.4943 19.2238 19.9297C18.998 20.365 18.5549 20.6373 18.0721 20.6373H1.92783C1.44507 20.6373 1.00193 20.365 0.776203 19.9297C0.550475 19.4943 0.579204 18.9674 0.850866 18.5602L3.4299 14.6951V9.873C3.4299 6.62104 5.70001 3.91027 8.71165 3.29933V1.81437C8.71165 1.0885 9.28844 0.5 9.99999 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ddd1f66aa979a0a34eb1345a5980439d.svg";
export { ForwardRef as ReactComponent };